// extracted by mini-css-extract-plugin
export default {"navBtn":"styles_navBtn__K07Ka","arrowLeftIcon":"styles_arrowLeftIcon__NWxdw","arrowRightIcon":"styles_arrowRightIcon__mwCH9"};